import api from "../client.ts";

type UserType = {
  id: number;
  email: string;
  password: string;
  token: string;
  personnel_id: number;
  status: number;
  created_at: string;       // ou Date si parsé
  updated_at: string | null;
};

const getAll = async ():Promise<{size:number, data: UserType[]}> => {
  const { data } = await api.get("/user/readAll");
  return data;
};


export const userController = {getAll}